import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabButton = _resolveComponent("TabButton")!
  const _component_Sticky = _resolveComponent("Sticky")!

  return (_ctx.unref(_ctx.visibility) !== _ctx.Visibility.None)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["tab-family-container", { ..._ctx.unref(_ctx.classes), ..._ctx.tabClasses }]),
        style: _normalizeStyle([
            {
                visibility: _ctx.unref(_ctx.visibility) === _ctx.Visibility.Hidden ? 'hidden' : undefined
            },
            _ctx.unref(_ctx.style) ?? [],
            _ctx.tabStyle ?? []
        ])
      }, [
        _createVNode(_component_Sticky, { class: "tab-buttons-container" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["tab-buttons", { floating: _ctx.floating }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unref(_ctx.tabs), (button, id) => {
                return (_openBlock(), _createBlock(_component_TabButton, _mergeProps({
                  onSelectTab: ($event: any) => (_ctx.selected.value = id),
                  floating: _ctx.floating,
                  key: id,
                  active: _ctx.unref(button.tab) === _ctx.unref(_ctx.activeTab)
                }, _ctx.gatherButtonProps(button)), null, 16, ["onSelectTab", "floating", "active"]))
              }), 128))
            ], 2)
          ]),
          _: 1
        }),
        (_ctx.unref(_ctx.activeTab))
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.unref(_ctx.component)), { key: 0 }))
          : _createCommentVNode("", true)
      ], 6))
    : _createCommentVNode("", true)
}